module.exports = __webpack_public_path__ + "static/media/3.872fba7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/3.png
// module id = 1508
// module chunks = 0